module.exports = __webpack_public_path__ + "img/2.ded80b65.jpg";